import { Component, EventEmitter, Input, Output, OnInit, AfterViewInit, ElementRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Component({
  selector: 'row-checkbox',
  template: `<input type="checkbox" class="row-check-box" (change)="change()" [ngModel]="isSelected" />`,
  styles: [
    `
input.row-check-box[type="checkbox"]:focus{
  outline: 0 !important;
}

input.row-check-box {
  -webkit-appearance: none;
  background-color: #fafafa;
  border: 2px solid #AFB3B6;
  padding: 6px !important;
  margin: 0px !important;
  display: inline-block;
  height: 15px;	width: 15px;
  position: relative;
}

input.row-check-box:checked {
  background: #0076CC;
  border: 2px solid #0075CB;
}

input.row-check-box:checked:after {
  content: "\\2713";
  color: #fff;
  position: absolute;
  left: 45%;
  top: 45%;
  -webkit-transform: translate(-50%,-50%);
  -moz-transform: translate(-50%,-50%);
  -ms-transform: translate(-50%,-50%);
  transform: translate(-50%,-50%);
}`
  ]
})
export class RowCheckBoxComponent implements OnInit, AfterViewInit {
  @Output() onChange = new EventEmitter<boolean>();
  isSelected: boolean;
  @Input() isCheckboxSelected: BehaviorSubject<boolean>;

  constructor(private el: ElementRef) {
  }

  ngOnInit() {
    this.isCheckboxSelected.subscribe(isSelected => {
      this.isSelected = isSelected;
    });
  }

  ngAfterViewInit() {
  }

  change(): void {
    this.isSelected = !this.isSelected;
    this.onChange.emit(this.isSelected);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/grids/row-checkbox.component.ts